import React, { useState } from 'react';
import axios from 'axios';
import { KeyRound, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { AccountDialog, accountError } from './AccountDialog';

export const ChangePasswordDialog = ({ forced = false, onClose, onChanged, onLogout }) => {
  const [current, setCurrent] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const submit = async event => {
    event.preventDefault(); setError('');
    if (password.length < 8) return setError('Шинэ нууц үг 8-аас багагүй тэмдэгт байна');
    if (password === current) return setError('Шинэ нууц үг хуучинтай ижил байж болохгүй');
    if (password !== confirm) return setError('Шинэ нууц үгүүд таарахгүй байна');
    setBusy(true);
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/admin/me/change-password`,
        { current_password: current, new_password: password },
        { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });
      setCurrent(''); setPassword(''); setConfirm(''); onChanged(data.token);
    } catch (e) { setError(accountError(e)); }
    finally { setBusy(false); }
  };
  return <AccountDialog id="change-password-dialog" title="Нууц үг солих" forced={forced} onClose={onClose}
    description={forced ? 'Үргэлжлүүлэхийн өмнө түр нууц үгээ солино уу.' : 'Бусад төхөөрөмж дээр дахин нэвтрэх шаардлагатай болно.'}>
    <form onSubmit={submit} data-testid="change-password-form" className="space-y-4">
      <label className="block text-sm">Одоогийн нууц үг<Input data-testid="current-password-input" autoComplete="current-password" type="password" required value={current} onChange={e => setCurrent(e.target.value)} className="mt-2" /></label>
      <label className="block text-sm">Шинэ нууц үг<Input data-testid="new-password-input" autoComplete="new-password" type="password" required minLength={8} value={password} onChange={e => setPassword(e.target.value)} className="mt-2" /></label>
      <label className="block text-sm">Шинэ нууц үг давтах<Input data-testid="confirm-password-input" autoComplete="new-password" type="password" required value={confirm} onChange={e => setConfirm(e.target.value)} className="mt-2" /></label>
      {error && <p role="alert" data-testid="change-password-error" className="text-sm break-words border-l-2 border-red-500 pl-3">{error}</p>}
      <div className="flex flex-wrap gap-3 pt-2">
        <Button type="submit" disabled={busy} data-testid="change-password-submit" className="flex-1 gap-2">{busy ? <Loader2 size={16} className="animate-spin" /> : <KeyRound size={16} />}Солих</Button>
        <Button type="button" variant="outline" disabled={busy} data-testid="change-password-cancel" onClick={forced ? onLogout : onClose}>{forced ? 'Гарах' : 'Болих'}</Button>
      </div>
    </form>
  </AccountDialog>;
};